import { isDevelopment } from "./environment";

export const passwordRegex =
  /^(?=.*[a-zA-Z])(?=.*[!@#$%^*+=-])(?=.*[0-9]).{8,20}$/;

export const emailRegex = isDevelopment
  ? /^[0-9a-zA-Z]([-_.+]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/
  : /^(?:[0-9a-zA-Z](?:[-_.]?[0-9a-zA-Z])*@(?!ecoya\.kr)[0-9a-zA-Z](?:[-_.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}|[0-9a-zA-Z](?:[-_.+]?[0-9a-zA-Z])*@ecoya\.kr)$/;

export const englishOnlyPattern = /^[a-zA-Z0-9\s.,#\-/()&']*$/;
